import { render, staticRenderFns } from "./DuaMessageUnknown.vue?vue&type=template&id=d114ef4a"
import script from "./DuaMessageUnknown.vue?vue&type=script&lang=js"
export * from "./DuaMessageUnknown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports